import Vue from 'vue'
import VueI18n from 'vue-i18n'
import * as zhLocale from './modules/zh'; // 导入中文语言包模块
import * as enLocale from './modules/en';
import * as zhTwLocale from './modules/zh_tw';

  Vue.use(VueI18n)

  const messages = {
    // english
    en: {
      ...enLocale,
    },
    // chinese
    zh: {
     ...zhLocale,
    },
    zh_tw:{
      ...zhTwLocale,
    }
  }

  export function getLanguage(): string {
    // // get language type from local storage
    // const chooseLanguage = localStorage.getItem('language')
    // if (chooseLanguage) return chooseLanguage
  
    // // if has not choose language
    // const language = (navigator.language).toLowerCase()
    // const locales = Object.keys(messages)
    // for (const locale of locales) {
    //   if (language.indexOf(locale) > -1) {
    //     return locale
    //   }
    // }
    let chooseLanguage = localStorage.getItem('xlanguage');
    chooseLanguage = chooseLanguage && chooseLanguage.replace(/\"/g,"");
    if(chooseLanguage!=null && (chooseLanguage.indexOf('zh')!=-1 || chooseLanguage.indexOf('en')!=-1 || chooseLanguage.indexOf('zh_tw')!=-1)){
      return chooseLanguage;
    }
    return "zh"
  }
  const i18n = new VueI18n({
    // set locale
    // options: en | zh 
    locale: getLanguage(),
    // set locale messages
    messages
  })
  
  export default i18n